export const CART_ACTION_TYPES = {
  ADD_TO_CART: "ADD_TO_CART",
  SUBTRACT_FROM_CART: "SUBTRACT_FROM_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
};